import { OnlinePickupBanner } from './OnlinePickupBanner';
export default OnlinePickupBanner;